import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import CyberMemorialService from '../../services/FamilyPlaza/CyberMemorialService';

const ContractorAuthenticationModal = ({ isOpen, onClose, onConfirm }) => {
  const [contractorName, setContractorName] = useState('');
  const [contractorBirth, setContractorBirth] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Format contractor birthday for API: if value is YYYYMMDD -> convert to YYYY-MM-DD
  // If already in YYYY-MM-DD keep as is; otherwise return trimmed original
  const formatBirthForApi = (value) => {
    if (!value) return '';
    const trimmed = value.trim();
    // Already in dashed format YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed;
    }
    // If 8 digits, convert to dashed format
    const digitsOnly = trimmed.replace(/[^0-9]/g, '');
    if (/^\d{8}$/.test(digitsOnly)) {
      const y = digitsOnly.substring(0, 4);
      const m = digitsOnly.substring(4, 6);
      const d = digitsOnly.substring(6, 8);
      return `${y}-${m}-${d}`;
    }
    return trimmed;
  };

  const handleConfirm = async () => {
    if (!contractorName.trim() || !contractorBirth.trim()) {
      setError('계약자명과 생년월일을 모두 입력해주세요.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const apiData = {
        customerName: contractorName.trim(),
        customerBirthday: formatBirthForApi(contractorBirth)
      };
      const response = await CyberMemorialService.verifyContractorAuthentication(apiData);
      
        if (response && response.status === 'SUCCESS' && response.data && response.data.length > 0) {
          // Get current selected person data to create unique authentication key
          const selectedPersonData = JSON.parse(localStorage.getItem('selectedPersonData') || '{}');
          const goinId = selectedPersonData.goinId;
          
          if (goinId) {
            // Store authentication per deceased person using goinId
            localStorage.setItem(`modalAuthenticated_${goinId}`, 'true');
            localStorage.setItem(`authenticatedCustomerName_${goinId}`, response.data[0].customerName);
            localStorage.setItem(`authenticatedCustomerBirthday_${goinId}`, apiData.customerBirthday);
            localStorage.setItem(`modalAuthenticationTimestamp_${goinId}`, Date.now().toString());
            
            // Also store the current goinId for easy reference
            localStorage.setItem('currentAuthenticatedGoinId', goinId);
          } else {
            // Fallback to global authentication if no goinId (shouldn't happen in normal flow)
            localStorage.setItem('modalAuthenticated', 'true');
            localStorage.setItem('authenticatedCustomerName', response.data[0].customerName);
            localStorage.setItem('authenticatedCustomerBirthday', apiData.customerBirthday);
            localStorage.setItem('modalAuthenticationTimestamp', Date.now().toString());
          }
          
          onConfirm();
        } else {
          setError('인증에 실패했습니다. 계약자명과 생년월일을 확인해주세요.');
        }
      
    } catch (error) {
     
      setError('인증에 실패했습니다. 계약자명과 생년월일을 확인해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="contractor-authentication-modal-overlay">
      <div className="contractor-authentication-modal">
        <div className="contractor-authentication-modal-header">
          <h2 className="contractor-authentication-modal-title">계약자 인증</h2>
          <button className="contractor-authentication-modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>
        
        <div className="contractor-authentication-modal-content">
          <p className="contractor-authentication-modal-instruction">
            헌화하기, 추모글 등록하기, 추모앨범 등록하기 기능을 사용하시려면 계약자 이름/생년월일을 입력하셔야 합니다.
          </p>
          
          <div className="contractor-authentication-modal-form">
            <div className="contractor-authentication-modal-field">
              <label className="contractor-authentication-modal-label">계약자명</label>
              <input
                type="text"
                className="contractor-authentication-modal-input"
                value={contractorName}
                onChange={(e) => setContractorName(e.target.value)}
                placeholder="홍길동"
              />
            </div>
            
            <div className="contractor-authentication-modal-field">
              <label className="contractor-authentication-modal-label">계약자 생년월일</label>
              <input
                type="text"
                className="contractor-authentication-modal-input"
                value={contractorBirth}
                onChange={(e) => setContractorBirth(e.target.value)}
                placeholder="예) 19750520"
              />
            </div>
          </div>
          
          <div className="contractor-authentication-modal-hint">
            <p>• 계약자 인증은 접속 시 매 1회만 진행됩니다.</p>
          </div>
          
          {error && (
            <div className="contractor-authentication-modal-error">
              <p>{error}</p>
            </div>
          )}
        </div>
        
        <div className="contractor-authentication-modal-footer">
          <button 
            className="contractor-authentication-modal-confirm-btn" 
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? '인증 중...' : '확인'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContractorAuthenticationModal; 